import { client } from "../client";
import type { Paginated, PaginatedFilter } from "../types/axios.types";
import type { Center } from "../types/center.types";
import type { Enterprise } from "../types/enterprises.types";

export const fetchEnterprises = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
	isArchived?: boolean,
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	if (isArchived !== undefined && isArchived !== null) {
		params.append("isArchived", isArchived.toString());
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Enterprise[]>>(`enterprises/`, {
		params,
	});
	return response.data;
};

export const fetchEnterpriseCenters = async (
	id: number,
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	if (id === undefined) {
		return null;
	}
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Center[]>>(
		`enterprises/${id}/centers`,
		{
			params,
		},
	);
	return response.data;
};

export const fetchEnterprise = async (
	id: number | string | null | undefined,
) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.get<Enterprise>(`enterprises/${id}`);
	return response.data;
};
